module.exports = __webpack_public_path__ + "static/media/aggregate.4d628901.svg";